import { useRouteError } from "react-router";

import { OAuthCallbackPage } from "@/shared/components/OAuthCallback/OAuthCallbackPage";
import { userFacingErrorMessage } from "@/shared/http";
import { Goto } from "@/shared/navigation/Goto";

import { renderSlackConnectError } from "./slackOAuthCopy";
import { SLACK_OAUTH_MESSAGES } from "./slackOAuthMessages";

/**
 * The Slack callback route's error element: what renders when its loader throws instead of
 * returning a view.
 *
 * Without one, the throw reaches the root `ErrorPage`, which replaces the whole tree — so the
 * popup never posts to its opener, and the integration page's abandonment poll tells the admin
 * they dismissed a window that actually crashed. Rendering the same `OAuthCallbackPage` the
 * settled path uses keeps that report on every failure.
 */
export function SlackOAuthCallbackError() {
  const error = useRouteError();

  return (
    <OAuthCallbackPage
      view={{
        status: "error",
        message: userFacingErrorMessage(error),
        // A crash is not a verdict on the URL, and a loader that threw may never have reached
        // the exchange — so leave the params in place and let a reload retry.
        paramLevel: false,
        stripQuery: false,
      }}
      messageTypes={SLACK_OAUTH_MESSAGES}
      // Required by the shared page, unreachable here: this element renders only for a throw.
      successMessage={null}
      renderError={renderSlackConnectError}
      standaloneRedirectPath={Goto.route.SlackIntegration}
    />
  );
}
